import React from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import { phoneModalNumberState, phoneModalState } from './atom'
import { ModalBase, Text, Stack } from '@/presentation/components'
import { Linking, Alert, Platform, View } from 'react-native'
import { theme } from '@/presentation/styles'
import { Button } from 'react-native-paper'

export const PhoneModal: React.FC = () => {
  const [modalIsOpen, setModalOpen] = useRecoilState(phoneModalState)
  const phoneNumber = useRecoilValue(phoneModalNumberState)

  if (!phoneNumber) {
    return null
  }

  const phoneNumbers = phoneNumber.split('\n').filter(phone => phone.trim() !== '')

  const handleCloseModal = (): void => {
    setModalOpen(false)
  }

  const extractDigits = (text: string): string => {
    return text.replace(/\D/g, '')
  }

  const handleCall = async (rawText: string): Promise<void> => {
    const digits = extractDigits(rawText)
    if (!digits) {
      Alert.alert('Erro', 'Número inválido')
      return
    }

    const url = Platform.OS === 'ios' ? `telprompt:${digits}` : `tel:${digits}`
    const supported = await Linking.canOpenURL(url)
    if (supported) {
      await Linking.openURL(url)
      handleCloseModal()
    } else {
      Alert.alert('Erro', 'Não foi possível realizar a ligação')
    }
  }

  return (
    <ModalBase
      visible={modalIsOpen}
      onClose={handleCloseModal}
      key={`id-${phoneNumber}`}
    >
      <Text variant='h5' style={{ marginBottom: 16 }}>Contato(s)</Text>

      <Stack style={{ gap: 10 }}>
        {phoneNumbers.map((item, index) => {
          const parts = item.split('-')
          const cidade = parts[0]?.trim() || ''
          const telefone = parts.slice(1).join('-').trim() || item.trim()

          return (
            <View
              key={index}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 2
              }}
            >
              <Text variant='h6'>{cidade}</Text>
              <Button
                icon='phone'
                onPress={async () => await handleCall(item)}
                buttonColor={theme.colors.info}
                textColor={theme.colors.white}
              >
                {telefone}
              </Button>
            </View>
          )
        })}
      </Stack>
    </ModalBase>
  )
}
